import axios from 'axios';

/*
 * Used for api calls for current user.
 * for example: profile, get my tenants, ...
 */
const userApi = {
  async getMe() {
    const response = await axios.get('/api/user');
    return response.data;
  },
  async getMeWorker(userId) {
    return await axios({
      url: '/api/tenant/worker/byuserid/' + userId,
    }).then(r => r.data);
  },
  async getUser(id) {
    const response = await axios.get('/api/user/' + id);
    return response.data;
  },
  async getAllUsers() {
    const response = await axios.get('/api/user/list-cloud');
    return response.data;
  },
  async updateUserInfo(email, firstName, lastName, phone) {
    const data = {
      email,
      firstName,
      lastName,
      phone,
    };
    const response = await axios.post('/api/user', data);
    return response.data;
  },
  async uploadProfileImage(file, imageFilename) {
    const formData = new FormData();
    formData.append('file', file, imageFilename);
    const response = await axios.post(`/api/user/image`, formData);
    return response.data;
  },
  async logout() {
    await axios.post('/logout');
  },
};

export default userApi;
